import {observer} from 'mobx-react-lite'
import React, {useState} from 'react'
import {Sticker} from '@components/common/base/sticker/sticker'
import IconDots from '../../common/icons/icons-common/icon-dots.svg'
import {useStickerEditorStore} from '../sticker-editor-store'
import {StringStateActions} from './string-state-actions'
import {StringStateItemProps} from './types'
import {useActionHandlers} from './use-action-handlers'
import {useDragHandlers} from './use-drag-handlers'
import {useHoverHandlers} from './use-hover-handlers'

const draggedStyle = {
  transition: '0.01s',
  transform: 'translateX(-9999px)'
}

export const StringStateItem = observer(
  ({stringStickerState}: StringStateItemProps) => {
    const [state, store] = useStickerEditorStore()
    const [hovered, setHovered] = useState<boolean>(false)
    const [pressed, setPressed] = useState<boolean>(false)

    const handlerProps = {stringStickerState, store, state}
    const {dragEnter, dragStart, dragEnd} = useDragHandlers(handlerProps)
    const {edit, del} = useActionHandlers(handlerProps)

    const draggedState = stringStickerState.id === state.stringStateDragged?.id

    const {onMouseEnter, onMouseLeave, onMouseDown} = useHoverHandlers({
      setHovered,
      setPressed
    })

    return (
      <div
        className="flex flex-row"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onMouseDown={onMouseDown}
      >
        <div
          draggable
          onDragEnter={dragEnter}
          onDragStart={dragStart}
          onDragEnd={dragEnd}
          className="flex items-center gap-8 truncate"
          style={draggedState ? draggedStyle : {}}
        >
          <IconDots className="flex shrink-0 text-third-old" />
          <Sticker
            onClick={edit}
            color={stringStickerState.color}
            iconColor={`icon-${stringStickerState.color}`}
            iconBackgroundColor={`icon-${stringStickerState.color}`}
            icon={state.stickerIcon}
            title={stringStickerState.name}
            active={pressed}
          />
        </div>
        {hovered && <StringStateActions edit={edit} del={del} />}
      </div>
    )
  }
)
